<template>
  <div class="settingView">
    <div class="aboutView">
      <div class="noticeContent">
        <div class="noticeContent_menu">
          <mpLeftMenu :menus="menus"></mpLeftMenu>
        </div>
        <div class="contextStyle">
          <div class="menuStyle">
            <mpBreadcrumb :breadcrumb="menus"></mpBreadcrumb>
          </div>
          <div class="contextStyle_context">
            <div class="menuStyleAfter" v-if="menus[1].active === 0">
              <userMsg></userMsg>
            </div>
            <div v-if="menus[1].active === 1">
              <resetPwd></resetPwd>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import resetPwd from "./components/resetPassword.vue";
import userMsg from "./components/userMsg.vue";
import mpLeftMenu from "@/components/mp-left-menu/mp-left-menu.vue";
import mpBreadcrumb from "@/components/mp-breadcrumb/mp-breadcrumb.vue";
export default {
  components: {
    userMsg,
    resetPwd,
    mpLeftMenu,
    mpBreadcrumb
  },
  data() {
    return {
      activeName: "0",
      menus: [
        {
          active: 9,
          menu: [{ id: 9, icon: "ios-notifications-outline", text: "账号设置" }]
        },
        {
          active: 0,
          menu: [
            { id: 0, icon: "md-person", text: "个人信息" },
            // { icon: "ios-paper-outline", text: "绑定邮箱" },
            { id: 1, icon: "md-key", text: "修改密码" }
            // { icon: "ios-book-outline", text: "修改邮箱" }
          ]
        }
      ]
    };
  },
  methods: {
    //选择的时候改变
    onSelect(name) {
      this.activeName = name;
    }
  }
};
</script>
<style lang="scss" scoped>
@import "../../../public/static/style/page.less";
.noticeView {
}
.noticeContent {
  max-width: 1300px;
  display: flex;
  justify-content: flex-start;
  padding-top: 5px;
  padding-bottom: 20px;
}
.noticeContent_menu {
  padding-top: 40px;
}
.noticeMuen {
  color: #2d8cf0;
  height: 35px;
}
.contextStyle {
  padding: 0 20px;
  width: 100%;
  .menuStyle {
    height: 40px;
    line-height: 40px;
  }
  .contextStyle_context {
    margin-top: 20px;
    width: 100%;
  }
  .contextStyle_page {
    background: #e8eaec;
    margin: 10px 0;
    min-height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-top: 1px solid #e8eaec;
    border-bottom: 1px solid #e8eaec;
  }
}
</style>
